import * as ApiKeyActions from '../actions/api-key';
import { ApiKeysResponse } from '../../services/api-keys/api-keys.model';

export type State = ApiKeysResponse;

export const InitialState: State = {};

export function reducer(state: State = InitialState, action: ApiKeyActions.All): State {
	switch (action.type) {

		case ApiKeyActions.ADD_API_KEYS:
			return {...state, ...(<ApiKeyActions.AddApiKeys>action).payload};

		case ApiKeyActions.REMOVE_API_KEY:
			const newState = {};

			Object.keys(state).forEach(key => {
				if (key !== action.payload) {
					newState[key] = state[key];
				}
			});

			return newState;

		default:
			return state;
	}
}



// WEBPACK FOOTER //
// ./src/app/shared/state-management/reducers/api-key.ts